<script lang="ts">
  import Typography from "$lib/components/Typography/Typography.svelte";
  export let title = "";
</script>

<style lang="scss">
  .page-title {
    padding: 32px 0 16px;

    @include breakpoint(md) {
      padding: 24px 0 20px;
    }

    @include breakpoint(lg) {
      padding: 16px 0 24px;
    }
  }
</style>

<div class="page-title">
  <Typography component="h1" variant="h1">{title}</Typography>
</div>
